'use client';

import Link from 'next/link';
import { useFathomEvent } from '@/lib/hooks/useFathomEvent';
import { FATHOM_EVENTS } from '@/lib/fathom-events';

type QuickStartLinkProps = {
  href: string;
  children: React.ReactNode;
};

export default function QuickStartLink({ href, children }: QuickStartLinkProps) {
  const trackQuickStartClick = useFathomEvent(FATHOM_EVENTS.scans['how-to'].quickstart_link.click);

  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="underline underline-offset-4"
      onClick={trackQuickStartClick}
    >
      {children}
    </Link>
  );
}
